module.exports = __webpack_public_path__ + "static/media/SortedNewDown.cb64b2d8.svg";